module.exports = __webpack_public_path__ + "static/img/3.e7bf790.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/3.png
// module id = Dipv
// module chunks = 0